import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How much does it cost to develop an app in UAE?",
    answer: ` <p>The whole cost of mobile app development in Dubai ranges from $40,000 to $300,000 (150k AED to 1100k AED).</p>`,
  },
  {
    question: "Is Android app profitable?",
    answer: `<p>The proper monetization of a mobile app leads to great performance. This method works very well in Android apps, thus being an Android developer is becoming increasingly profitable, even in a market dominated by Apple.</p>
    <table class="table">
    <thead>
      <tr>
        <th scope="col">App Type</th>
        <th scope="col">Estimated Time</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Basic app development</td>
        <td>2-4 months</td>
      </tr>
      <tr>
        <td>Typical app development</td>
        <td>4-6 months</td>
      </tr>
      <tr>
        <td>Complicated app development</td>
        <td>9+ months</td>
      </tr>
    </tbody>
  </table> `,
  },
  {
    question: "How much does it cost to develop an app in Dubai?",
    answer: `<p>Here are the details on how much does it cost to develop an app in Dubai:</p> 
    <table class="table">
    <thead>
      <tr>
        <th scope="col">Mobile App Types</th>
        <th scope="col">Mobile App Development Cost</th>
        <th scope="col">Development Time Frame</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Tier 1 App(Low Complexity)</td>
        <td>AED 25,000 to AED 35,000</td>
        <td>2-5 Months</td>
      </tr>
      <tr>
      <td>Tier 2 App (Medium Complexity)</td>
      <td>AED 35,000 to AED 50,000</td>
      <td>5-7 Months</td>
      </tr>
      <tr>
      <td>Tier 3 App (High Complexity)</td>
      <td>AED 50,000 to AED 80,000</td>
      <td>8-12 Months</td>
      </tr>
    </tbody>
  </table>`,
  },
  {
    question: "Is it easy to start a company in Dubai?",
    answer: `<p>Forming a company is simple in Dubai. You can apply in person at the Department of Economic Development in the emirate where you intend to start your business.</p>`,
  },
  {
    question: "How many people does it take to make an app?",
    answer: `<p>At the very least, each project with the goal of developing a successful mobile app requires a team of four to ten individuals.</p>
    <p>For example, we had to assign six developers, one project manager, and one account manager to assist Adventure Aide with their product launch and expansion.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
